import { renderIf } from '../../../utils/render.utils';
import BottomSheet from '../BottomSheet/BottomSheet';
import List from '../List/List';
import ListItem from '../List/ListItem';
import Button from '../Button/Button';
import style from './BottomSheetLayout.css';

export default function BottomSheetLayout({
  showBottomSheet,
  title,
  items,
  titleStyle,
  selectedItem,
  onClose,
  onItemClick,
  onButtonClick,
  buttonTitle,
}) {
  return (
    <>
      {renderIf(
        showBottomSheet,
        <BottomSheet title={title} onCloseClick={onClose}>
          <List className={style[titleStyle]}>
            {renderIf(
              items.length,
              items.map(item => (
                <ListItem
                  key={item.type}
                  title={item.title}
                  icon={item.icon}
                  actionable
                  type={ListItem.Type.RADIO}
                  selected={selectedItem?.type === item.type}
                  onClick={() => onItemClick(item)}
                />
              )),
            )}
          </List>
          <Button fullWidth onClick={onButtonClick}>
            {buttonTitle}
          </Button>
        </BottomSheet>,
      )}
    </>
  );
}
